import { UnifiedIcon } from '@/components/UnifiedIcon';

/**
 * Disabled placeholder until Azure AD SSO is implemented.
 */
export function MicrosoftSsoButtonPlaceholder() {
  return (
    <button
      type="button"
      data-testid="agents-login-microsoft"
      disabled
      title="Microsoft sign-in coming soon"
      className="ds-button-secondary w-full py-2.5 text-sm opacity-60"
    >
      <UnifiedIcon name="WindowsLogo" weight="bold" className="h-4 w-4" />
      Continue with Microsoft
    </button>
  );
}
